var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heardertab"},[_c('ul',{staticClass:"heardertab-tab mb16"},_vm._l((_vm.tabList),function(item,index){return _c('li',{key:index,staticClass:"heardertab-tab-list",class:{
        active: _vm.currentNum == index,
      },on:{"click":function($event){return _vm.tabClick(item, index)}}},[_c('div',{staticClass:"content"},[_c('div',[_vm._v(_vm._s(item.name))]),_c('div',[_vm._v("数据统计情况")])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }